import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IMessageableEntity } from '../../interfaces/IMessageableEntity';

@Component({
  selector: 'ngx-users-selected',
  templateUrl: './users-selected.component.html',
  styleUrls: ['./users-selected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UsersSelectedComponent {
  @Input() usersSelected: IMessageableEntity[] = [];
  @Input() showTitle = true;
  @Output() usersSelectedChange = new EventEmitter<IMessageableEntity[]>();

  deleteUserSelected(user: IMessageableEntity) {
    const index = this.usersSelected.findIndex((item) => item.uid === user.uid);
    if (index === -1) {
      return;
    }
    this.usersSelected.splice(index, 1);
    this.usersSelectedChange.emit([...this.usersSelected]);
  }
}
